import { useGameServerAuto } from "@hooks/selectors/game.selectors";
import { FC } from "react";
import { GameIdProps } from ".";
import { Text } from '@constructor/components';

const GameServerName: FC<GameIdProps> = ({ game_id, ...props }) => {

    const game = useGameServerAuto(game_id);
    if (!game) {
        return null;
    }

    return (
        <Text text={game.name} {...props} />
    )
}

export default GameServerName;